module.exports = __webpack_public_path__ + "static/cOEUBG-e3ec37c35310ad63426fc58a81185620.png";